import React from 'react';
import {View, TouchableOpacity, StyleSheet} from 'react-native';
// import Text from '@/components/basic/text';
import agency from '@/assets/imgs/me/agency.webp';
import best from '@/assets/imgs/me/best.webp';
import theme from '@/style';
import LazyImage from '@basicComponents/image';
import {goTo, toAgentApply} from '@/utils';
import {IUserInfo} from '@/services/global.service';
import globalStore from '@/services/global.state';
import {useInnerStyle} from './me.hooks';
import linkstyles from './index.module.scss';
// import {Icon} from '@rneui/themed/dist/Icon';
const rightIcon = require('@components/assets/icons/me-list-item/right-icon.webp');

const MeLink = ({login}: {login: boolean; user: IUserInfo | undefined}) => {
  const {
    size: {mlintIconSize},
  } = useInnerStyle();
  const toMyBets = () => {
    if (!login) {
      goTo('Login');
      return;
    }
    // 这里需要修改跳转
    // goTo('Bets');
    globalStore.openSports.next(
      // 如果有live还需要在拼一层/live
      '/my-bets/open',
    );
  };
  const toAgency = () => {
    toAgentApply();
  };
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <TouchableOpacity style={styles.cardHalf} onPress={toMyBets}>
          <div className={linkstyles.link_container}>
            <div className={linkstyles.link_left}>
              {/* <TouchableOpacity style={styles.textContainer} onPress={toMyBets}> */}
              {/* <View style={styles.cardImg}> */}
              {/* <Image src={best} /> */}
              <View
                style={{
                  ...styles.cardImg,
                }}>
                <LazyImage
                  occupancy={'transparent'}
                  imageUrl={best}
                  width={mlintIconSize}
                  height={mlintIconSize}
                />
              </View>
              {/* </View> */}
              {/* </TouchableOpacity> */}

              <div className={linkstyles.link_span}>My Sports{'\n'}Bets</div>
            </div>

            <LazyImage
              occupancy={'transparent'}
              imageUrl={rightIcon}
              width={14}
              height={14}
            />
          </div>
        </TouchableOpacity>

        <TouchableOpacity style={styles.cardHalf} onPress={toAgency}>
          <div className={linkstyles.link_container}>
            <div className={linkstyles.link_left}>
              <div className={linkstyles.link_img_container}>
                <View
                  style={{
                    ...styles.cardImg,
                    ...styles.bgy,
                  }}>
                  <LazyImage
                    occupancy={'transparent'}
                    imageUrl={agency}
                    width={mlintIconSize}
                    height={mlintIconSize}
                  />
                  {/* <Image src={agency} /> */}
                </View>
              </div>
              <div className={linkstyles.link_span}>Agency{'\n'}Center</div>
            </div>

            <LazyImage
              occupancy={'transparent'}
              imageUrl={rightIcon}
              width={14}
              height={14}
            />
          </div>

          {/* <Icon name="arrow-right" size={16} color="#999999" /> */}
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    // padding: theme.paddingSize.l,
    // paddingBottom: theme.paddingSize.l,
    gap: theme.paddingSize.m,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.paddingSize.m,
  },
  cardHalf: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    // padding: theme.paddingSize.l,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    // gap: theme.paddingSize.m,
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flex: 1,
  },
  text: {
    flex: 1,
    fontSize: 12,
    color: '#252529',
    marginLeft: theme.paddingSize.s,
    // lineHeight: 20,
    fontFamily: 'Inter-Bold',
    alignSelf: 'center',
  },
  cardImg: {
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: '#EAF8FF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bgy: {
    backgroundColor: '#FFF8D9',
  },
});

export default MeLink;
